import React from 'react';
import Episodes from './ui/Episodes';

function App() {
  return (
    <div className="app-container font-sans">
      <Episodes />
    </div>
  );
}

export default App;